import mapboxgl from 'mapbox-gl';

const memberOrganisations = {};

(function (memberOrganisationsApp) {
    const filterModel = {
        Category: "",
        Country: "",
        Name: ""
    };

    let fromPopState = false;
    let blockPopstateEvent = true;
    const browserSupportsHistoryApi = window.history && 'pushState' in window.history;

    if (browserSupportsHistoryApi) {
        // prevent Chrome from calling onpopstate on initial load
        $(window).on('load', function () {
            // The timeout ensures that popstate-events will be unblocked right
            // after the load event occured, but not in the same event-loop cycle.
            setTimeout(function () { blockPopstateEvent = false; }, 0);
        });

        $(window).on('popstate', function () {
            if (blockPopstateEvent && document.readyState === "complete") {
                return;
            }
            fromPopState = true;
            performSearchFromUrl();
        });
    }

    function pushHistory() {
        if (browserSupportsHistoryApi && !fromPopState) {
            const currentPath = window.location.pathname;
            let query = "?";
            const queryArray = [];
            if (filterModel.Category) {
                queryArray.push("category=" + filterModel.Category);
            }
            if (filterModel.Country) {
                queryArray.push("country=" + filterModel.Country);
            }
            if (filterModel.Name) {
                queryArray.push("name=" + filterModel.Name);
            }
            query += queryArray.join("&");
            history.pushState(null, null, currentPath + query);
        }
        fromPopState = false;
    }

    function performSearchFromUrl() {
        filterModel.Category = null;
        filterModel.Country = null;
        filterModel.Name = null;

        if (window.location.search.length > 1) {
            for (let aItKey, nKeyId = 0, aCouples = window.location.search.substr(1).split("&");
                nKeyId < aCouples.length;
                nKeyId++) {
                aItKey = aCouples[nKeyId].split("=");
                if (aItKey.length <= 1)
                    continue;
                const key = decodeURIComponent(aItKey[0]).toLowerCase();
                const val = decodeURIComponent(aItKey[1]);

                if (key === "category") {
                    filterModel.Category = val;
                } else if (key === "country") {
                    filterModel.Country = val;
                } else if (key === "name") {
                    filterModel.Name = val;
                } 
            }
        }
        filterModel.IsPageReload = true;
        memberOrganisationsApp.GetFilterResults();
    }

    memberOrganisationsApp.InitializeMap = function () {
        if ($("#map-container").length) {
            const mapDiv = $("#map-container");
            let latitude = mapDiv.data("latitude");
            let longitude = mapDiv.data("longitude");
            const zoom = mapDiv.data("zoom");
            mapboxgl.accessToken = mapDiv.data("accesstoken");

            const map = new mapboxgl.Map({
                container: 'map-container',
                style: mapDiv.data("styleurl"),
                center: [longitude, latitude],
                zoom: zoom,
                cooperativeGestures: true
            });

            
            map.addControl(new mapboxgl.NavigationControl());

            mapDiv.siblings("#map-markers").find(".marker").each(function () {
                let element = document.createElement('div');
                element.className = 'map-marker';
                element.innerHTML = document.getElementById('marker-icon').innerHTML;

                if ($(this).attr('id') != undefined) element.id = $(this).attr('id');

                latitude = $(this).data("latitude");
                longitude = $(this).data("longitude");

                const markerCoordinates = [longitude, latitude];
                let marker = new mapboxgl.Marker(element)
                    .setLngLat(markerCoordinates);

                if ($(this).find(".popup-content").length) {
                    let popup = new mapboxgl.Popup({ offset: 25, maxWidth: 'none', focusAfterOpen: false, closeButton: false })
                        .setHTML($(this).find(".popup-content").html());
                    marker.setPopup(popup);
                }

                marker.addTo(map);
                $(this).remove();
            });


            $("#map-container").on("click", ".js-close-popup", function () {
                $('.mapboxgl-popup').remove();
            });
        }
    }

    memberOrganisationsApp.GetFilterResults = function () {
        $.ajax({
            url: "/umbraco/surface/MemberOrganisationSurface/FilterMemberOrganisationMap",
            type: "GET",
            data: filterModel,
            dataType: "html",
            success: function (data) {
                $(".js-map-result").html(data);
                memberOrganisationsApp.InitializeMap();
                pushHistory();
            },
            error: function (xhr, status, error) {
                console.log(status);
                console.log(xhr.status + " - " + error);
            }
        });
    };

    $(document).ready(function () {

        //Get url params on load
        const urlParams = new URLSearchParams(window.location.search);

        //check if querystring params exist on load/reload
        if (urlParams.get('category'))
            filterModel.Category = urlParams.get('category');

        if (urlParams.get('country'))
            filterModel.Country = urlParams.get('country');

        if (urlParams.get('name'))
            filterModel.Name = urlParams.get('name');
        
        memberOrganisationsApp.InitializeMap();
        
        $(document).on("submit", "#mapfilter-form", function (e) {
            e.preventDefault();
            filterModel.Category = $("#selectPractioner").find(":selected").val();
            filterModel.Country = $("#searchCountry").val();
            filterModel.Name = $("#searchName").val();

            memberOrganisationsApp.GetFilterResults();
        });

        $(document).on("change", "#selectPractioner", function (e) {
            $("#mapfilter-form").submit();
        });

        $(document).on("click", "#js-mapfilter-search", function (e) {
            $("#mapfilter-form").submit();
        });
         
    }); // document ready
})(memberOrganisations);
